import React from "react";
import { useNavigate } from "react-router-dom";
import Portfolio from "../Components/Portfolio";

const PortfolioPage = ({ data }) => {
  const navigate = useNavigate();

  return (
    <div>
      <div className="porfolio-header">
        <button className="portfolio-btn" onClick={() => navigate("/")}>
          Home
        </button>
      </div>
      {/* فقط بخش portfolio به کامپوننت Portfolio پاس داده شود */}
      <Portfolio data={data.portfolio} />
    </div>
  );
};

export default PortfolioPage;
